import React from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { AppState } from "store";
import { maskedPhoneNumber } from "shared/helpers";

const Phone: React.FC = (props: any) => {
  const { t } = useTranslation();
  const { anonymization } = useSelector((state: AppState) => state.auth);

  return (
    <div style={{ position: "relative", width: "100%" }}>
      <PhoneInput
        value={anonymization ? null : props.input.value}
        onChange={props.input.onChange}
        inputProps={{
          style: {
            width: "100%",
            height: 48,
          },
          disabled: anonymization,
        }}
        specialLabel={t("users.detail.phone")}
        country="cz"
        placeholder={anonymization ? (null as any) : undefined}
      />
      {anonymization ? (
        <div
          style={{
            position: "absolute",
            top: "28%",
            left: "21%",
            pointerEvents: "none",
          }}
        >
          {maskedPhoneNumber(props.input.value)}
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

export default Phone;
